import React from "react";
import { format } from "date-fns";
import { PuzzleDataContext } from "../../providers/PuzzleData";
import { SPORT_LABELS } from "../../lib/constants";

function NoPuzzle() {
    const { puzzleDate, sport } = React.useContext(PuzzleDataContext);

    const sportLabel = SPORT_LABELS[sport] ?? sport?.toUpperCase();
    const dateStr = puzzleDate ? format(puzzleDate, "MMMM d, yyyy") : "today";

    return (
        <div className="w-full max-w-[680px] px-4 sm:px-6">
            <div className="text-center mb-6 sm:mb-8 md:mb-10">
                <p className="text-sm sm:text-base uppercase tracking-[0.15em] text-slate-400 mb-3 sm:mb-4">
                    {sportLabel} daily
                </p>
                <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight px-4">
                    No Puzzle Available
                </h3>
            </div>

            <div className="game-wrapper">
                <div className="text-center space-y-6 sm:space-y-8 py-12 sm:py-16">
                    <div className="space-y-2 sm:space-y-3">
                        <p className="text-lg sm:text-xl md:text-2xl text-slate-200 px-4">
                            No puzzle available for {dateStr}
                        </p>
                        <p className="text-base sm:text-lg text-slate-400">
                            Check back later or try a different sport
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NoPuzzle;
